module.exports = __webpack_public_path__ + "img/block-768.ddc3320c.jpg";